var _templateObject;
var _excluded = ["top", "right", "bottom", "left"];
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
import { convertStyleValue } from '../../utils/js-style-to-css';
var AbsoluteContainer = function AbsoluteContainer(_ref) {
  var top = _ref.top,
    right = _ref.right,
    bottom = _ref.bottom,
    left = _ref.left,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("span", otherProps);
};
AbsoluteContainer.defaultProps = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
};
var StyledAbsoluteContainer = styled(AbsoluteContainer)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  bottom: ", ";\n  left: ", ";\n"])), function (props) {
  return convertStyleValue(props.top, 'top');
}, function (props) {
  return convertStyleValue(props.right, 'right');
}, function (props) {
  return convertStyleValue(props.bottom, 'bottom');
}, function (props) {
  return convertStyleValue(props.left, 'left');
});
export default StyledAbsoluteContainer;